import { number, object } from 'yup'

const rateOfReturnOptions = []
let i = 3
while (i <= 12) {
  rateOfReturnOptions.push({
    label: `${i} %`,
    value: i,
  })
  i++
}

export const formFields = {
  wealth: {
    label: 'How much will you have accumulated by the time you retire?',
    type: 'text',
    class: 'Currency',
  },
  annualAllowance: {
    label:
      'On an annual basis, what do you estimate your retirement living expenses to be?',
    type: 'text',
    class: 'Currency',
  },
  rateOfReturn: {
    label: 'What is your expected annual rate of return?',
    type: 'select',
    options: rateOfReturnOptions,
  },
}

export const formSchema = object().shape({
  wealth: number().typeError('must be a number').required('this is required'),
  annualAllowance: number()
    .typeError('must be a number')
    .required('this is required')
    .test(
      'less',
      'annual amount must be less then accumulated',
      (value, context) => {
        return value < context.parent.wealth
      },
    ),
})
